import assign from "lodash/fp/assign";
import ToastCtrl from "./toast/toast.controller";
import ToastTmpl from "./toast/toast.html";
import constants from "../../core/constants";

class Controller {
  constructor($timeout, Events, $mdToast) {
    "ngInject";

    this.$timeout = $timeout;
    this.Events = Events;
    this.$mdToast = $mdToast;
    this.lastToast = {};
  }

  showToast(options) {
    // Support reading message from options object or optons.error object
    // Due to new error response schema from integration with oathkeeper
    const errorMessage = options.message || options.error.message;
    if (
      options.type === this.lastToast.type &&
      errorMessage === this.lastToast.message
    ) {
      return;
    }

    this.$mdToast.show({
      hideDelay: constants.notificationDelay,
      position: "bottom right",
      toastClass: "notification-toast",
      controller: ToastCtrl,
      controllerAs: "$ctrl",
      template: ToastTmpl,
      locals: {
        options,
      },
    });

    this.lastToast.type = options.type;
    this.lastToast.message = errorMessage;

    this.$timeout(() => {
      this.lastToast = {};
    }, constants.notificationDelay);
  }

  onShowNotification(options) {
    this.showToastToast(options);
  }
  onShowErrorNotification(options) {
    this.showToast(assign(options, { type: "error" }));
  }

  onShowSuccessNotification(options) {
    this.showToast(assign(options, { type: "success" }));
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType.onShowNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const successEvent = this.Events.eventsType.onShowSuccessNotification;

    this.Events.on(showNotificationEvent, this.onShowNotification.bind(this));
    this.Events.on(successEvent, this.onShowSuccessNotification.bind(this));
    this.Events.on(errorEvent, this.onShowErrorNotification.bind(this));
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/notification/notification.controller.js